import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { setColor } from "../../../../assets/styles/styles";
import Title from "../../components/Title";
import { default as Button } from "../../../../components/common/button/Button";
import { ReactComponent as CalendarSVG } from "../../../../assets/images/icons/Calendar.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/icons/editIcon.svg";
import PinkIntraverseWithoutBorderLogo from "../../../../assets/images/logos/intraPinkWithoutBorder.png";
import Pagination from "../../../../components/common/pagination/Pagination";
import { getAllClientsTag } from "../../../../api/ClientsTagController";
import Modal from "../../components/Modal";
import EditTag from "./components/EditTag";
// import { ClientTagData} from "./components/SampleClientTagData";

const ClientTag = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const ROWS_PER_PAGE = 9;
    const [visibleRows, setVisibleRows] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [clientTagData, setClientTagData] = useState([]);

    const [isModalEditOpen, setIsModalEditOpen] = useState(false);
        const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const allTags = await getAllClientsTag();
            const sortedTags = allTags.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setClientTagData(sortedTags);
            const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
            const endIndex = startIndex + ROWS_PER_PAGE;
            setVisibleRows(allTags.slice(startIndex, endIndex));
            setTotalPages(Math.ceil(allTags.length / ROWS_PER_PAGE));
        };

        fetchData();
    }, [currentPage]);

    const handleEdit = (item) => {
        setIsModalEditOpen(true);
        setSelectedRow(item);
    };

    return (
        <>
            <CardTable>
                <TableRow>
                    <Title
                        title={"Client Tag"}
                        description={
                            "Manage all client tags in Intraverse. Changes made here are automatically pushed to related environments."
                        }
                    />
                    <TableColumn>
                        <Button
                            variant={"OutlinedButton"}
                            // disabled={successMessageBanner !== ""}
                            label={"Create Client Tag"}
                            margin={"2rem 0 0 0"}
                            onClick={() => navigate("/console/client_tag/create")}
                        />
                    </TableColumn>
                </TableRow>
            </CardTable>

            <GridContainer>
                {visibleRows.map((item, index) => (
                    <Card key={index}>
                        <EditIconContainer onClick={() => handleEdit(item)}>
                            <StyledEditIcon />
                        </EditIconContainer>

                        <HeaderRow>
                            <LogoWrapper>
                                <MobileLogo src={PinkIntraverseWithoutBorderLogo} />
                            </LogoWrapper>
                            <TitleCard>{item.tag}</TitleCard>
                        </HeaderRow>
                        <InfoRow>
                            <b>Client Tag Name:</b> {item.tag}
                        </InfoRow>
                        {/* <InfoRow>
                            <b>Client Tag ID:</b> {item.roomPresetNames}
                        </InfoRow> */}
                        <InfoRow>
                            <b>Number of rooms:</b> {item.roomsCount}
                        </InfoRow>
                        <InfoRow>
                            <b>Number of Achievements:</b> {item.achievementsCount}
                        </InfoRow>
                        <InfoRow>
                            <b>Number of pop ups:</b> {item.clientPopupsCount}
                        </InfoRow>
                        <InfoRow>
                            <CalendarSVG /> {item.createdAt}
                        </InfoRow>
                    </Card>
                ))}
            </GridContainer>

            <Pagination
                totalNumber={clientTagData?.length}
                // visibleRows={searchInput.length === 0 ? visibleRows : filteredTableData}
                visibleRows={visibleRows}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                tag={"Client Tags"}
            />

            {isModalEditOpen && (
                <Modal
                    isOpen={isModalEditOpen}
                    setIsOpen={setIsModalEditOpen}
                    children={<EditTag closeModal={() => setIsModalEditOpen(false)} data={selectedRow} />}
                />
            )}
        </>
    );
};

export default ClientTag;

const CardTable = styled.div`
    display: flex;
    flex-direction: column;
`;

const TableRow = styled.div`
    display: flex;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const TableColumn = styled.div`
    flex: 1;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 25px;
    margin: 20px 0;
    min-height: 100vh;
`;

const Card = styled.div`
    position: relative;
    background-color: rgb(23, 22, 34);
    color: #fff;
    border-radius: 12px;
    border: 1px solid ${setColor.modalOutline};
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
    max-height: 400px;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    }
`;

const EditIconContainer = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    border-radius: 50%;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

const LogoWrapper = styled.div`
    width: 48px;
    height: 48px;
    background-color: #333; /* optional */
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MobileLogo = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const TitleCard = styled.h2`
    font-size: 20px;
    font-weight: 600;
`;

const InfoRow = styled.div`
    display: flex;
    gap: 8px;
    font-size: 14px;
    color: #aaa;
`;

const StyledEditIcon = styled(EditIcon)`
    width: 25px;
    height: 25px;
    cursor: pointer;
`;
